import Vue from 'vue'
import Vuex from 'vuex'

// 使用vuex
Vue.use(Vuex);


//创建Vuex实例
const store=new Vuex.Store({
  state:{
    token:localStorage.getItem('token'),
    username:localStorage.getItem('username'),
    avator:localStorage.getItem('avator'),
    address:localStorage.getItem('address'),
    is_vip:localStorage.getItem('is_vip'),
    nickname:localStorage.getItem('nickname'),
    sidebar_status:localStorage.getItem('sidebar_status'),//侧边栏
    role:localStorage.getItem('role')//侧边栏

  },

  mutations:{
    getnum(state,data){
      state.sidebar_status=data,
        localStorage.setItem('sidebar_status',state.sidebar_status)
    },

    set_userinfo(state,data){
      state.username=data.username,
      state.avator=data.avator,
      state.address=data.address,
      state.is_vip = data.is_vip,
      state.nickname = data.nickname,
      state.uid = data.uid,
      state.role = data.role,
      localStorage.setItem('username',state.username),
      localStorage.setItem('uid',state.uid),
      localStorage.setItem('nickname',state.nickname),
      localStorage.setItem('address',state.address),
      localStorage.setItem('avator',state.avator)
      localStorage.setItem('is_vip',state.is_vip)
      localStorage.setItem('role',state.role)
    },

    set_token(state, token) {
      state.token=token;
      localStorage.setItem(`token`,token)
    },

    del_token(state) {
      state.token ='';
      state.username ='';
      state.avator ='';
      state.address ='';
      state.is_vip ='';
      state.nickname ='';
      state.uid ='';
      localStorage.setItem('token', '')
      localStorage.setItem('uid', '')
      localStorage.setItem('username', '')
      localStorage.setItem('avator', '')
      localStorage.setItem('address', '')
      localStorage.setItem('is_vip', '')
      localStorage.setItem('nickname', '')
    },




  },


});


export default store //导出store






// WEBPACK FOOTER //
// ./src/vuex/index.js